export class FormContainerModel {
  type: "Modal" | "Tab";
  metadata: TabMetadata | ModalMetadata;
}
export interface TabMetadata {
  id: string;
}

export interface ModalMetadata {
  id: string;
}
